import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'empresas/clases-de-actividades-empresariales/';

/**
 * GET Clases de Actividades Empresariales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getClasesDeActividadesEmpresariales = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Clase de Actividad Empresarial
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getClaseDeActividadEmpresarial = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Clase de Actividad Empresarial
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClaseDeActividadEmpresarial = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Clase de Actividad Empresarial
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClaseDeActividadEmpresarial = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Clase de Actividad Empresarial
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteClaseDeActividadEmpresarial = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
